// extracted by mini-css-extract-plugin
export default {"container":"AuthContent_container__gt3JM"};